<template>
  <i class="pi pi-times clearerbut" @click="$emit('update:modelValue', null)" />
</template>

<script>
import { ref } from "vue";
export default {
  props: ["referer", "modelValue"],
  emits: ["update:modelValue"],
  setup(props) {
    const input = ref("");
    return { input };
  },
};
</script>

